import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'
import { FontSize } from 'common-constants/sizes'
import { mobileModalPaddingSize } from 'components/presentational'
import { ProfileName } from 'components/presentational/ProfileName/ProfileName'
import {
  CenterTooltip,
  TooltipContent,
} from 'components/presentational/Tooltip'

export const tooltipTop = 'calc(100% - 5px)'

export const Tooltip = styled(TooltipContent)`
  flex-shrink: 0;
  font-size: 12px;
  padding: ${mobileModalPaddingSize}px;
  word-wrap: break-word;
  box-sizing: border-box;
`

const userDetailCss = css`
  font-weight: bold;
  margin-bottom: 5px;
  color: ${Colors.black};
`

export const UserDetails = styled.div`
  ${userDetailCss};
`

export const StyledProfileName = styled(ProfileName)`
  ${userDetailCss};
  line-height: 16px;
`

export const SmallNoteText = styled.div<{ fontSize?: number }>`
  font-size: ${(props) => props.fontSize}px;
  color: ${Colors.location};
`

SmallNoteText.defaultProps = {
  fontSize: FontSize.note,
}

export const Message = styled.div`
  margin-top: 5px;
`

export const Content = styled(CenterTooltip)`
  top: calc(100% - 5px);
  word-wrap: break-word;
`
